import React, { useState } from 'react';
import './CityFilter.scss';
import activeCityCheck from '../../assets/icons/active-city-check.svg';
import dropdownCarret from '../../assets/icons/dropdown-carret.svg';

interface CityFilterProps {
  cities: string[];
  selectedCity: string;
  onCityChange: (city: string) => void;
}

export const CityFilter: React.FC<CityFilterProps> = ({
  cities,
  selectedCity,
  onCityChange,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleCitySelect = (city: string) => {
    onCityChange(city);
    setIsOpen(false);
  };

  return (
    <div className="city-filter">
      <button
        className={`city-filter__button ${isOpen ? 'open' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
        aria-haspopup="listbox"
      >
        <span>{selectedCity}</span>
        <img 
          src={dropdownCarret} 
          alt="carret"
          className={`city-filter__icon ${isOpen ? 'rotated' : ''}`}
        />
      </button>
      {isOpen && (
        <ul 
          className="city-filter__dropdown"
          role="listbox"
          aria-label="Select a city"
        >
          {[...cities].sort((a, b) => a.toLowerCase() === 'montreal' ? -1 : b.toLowerCase() === 'montreal' ? 1 : 0).map((city) => (
            <li 
              key={city}
              role="option"
              aria-selected={city === selectedCity}
            >
              <button
                className={`city-filter__option ${city === selectedCity ? 'selected' : ''}`}
                onClick={() => handleCitySelect(city)}
              >
                <span>{city}</span>
                {city === selectedCity && (
                  <img
                    src={activeCityCheck}
                    alt=""
                    className="city-filter__check"
                  />
                )}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
